{
    "account": "Account",
    "account-settings": "Accountinstellingen",
    "active": "Actief",
    "add-shopping-cart": "Aan winkelwagen toevoegen",
    "alert": "Waarschuwing",
    "align": "Uitlijnen",
    "align-justify": "Uitlijnen verantwoorden",
    "align-left": "Links uitlijnen",
    "align-right": "Rechts uitlijnen",
    "anchor": "Anker",
    "archive": "Archief",
    "arrow-circle-down": "Pijl cirkel omlaag",
    "arrow-circle-left": "Pijl cirkel links",
    "arrow-circle-right": "Pijl cirkel rechts",
    "arrow-circle-up": "Pijl cirkel omhoog",
    "arrow-down": "Pijl omlaag",
    "arrow-left": "Pijl links",
    "arrow-left-down": "Pijl links omlaag",
    "arrow-left-up": "Pijl links omhoog",
    "arrow-right": "Pijl rechts",
    "arrow-right-down": "Pijl rechts omlaag",
    "arrow-right-up": "Pijl rechts omhoog",
    "arrow-up": "Pijl omhoog",
    "at": "Bij",
    "attachment": "Bijlage",
    "award": "Prijs",
    "bagage": "Bagage",
    "bed": "Bed",
    "bell": "Bel",
    "bike": "Fiets",
    "bluetooth": "Bluetooth",
    "book": "Boek",
    "box": "Doos",
    "bullet-circle": "Bullet cirkel",
    "bullet-point": "Opsommingsteken",
    "calendar": "Kalender",
    "calendar-alt": "Kalender alt",
    "calendar-complete": "Kalender voltooid",
    "calendar-rounded": "Kalender rond",
    "camera": "Camera",
    "card": "Kaart",
    "card-alt": "Kaart alt",
    "charge": "Laden",
    "chart-1": "Diagram 1",
    "chart-2": "Diagram 2",
    "chat": "Chat",
    "check": "Controleren",
    "check-circle": "Vink cirkel",
    "check-square": "Selectievakje",
    "checkmark-circle": "Vinkje cirkel",
    "cheers": "Proost",
    "chevron-down": "Chevron omlaag",
    "chevron-left": "Chevron links",
    "chevron-right": "Chevron rechts",
    "chevron-up": "Chevron omhoog",
    "chevrons-down": "Dubbele pijlen omlaag",
    "chevrons-left": "Chevrons links",
    "chevrons-right": "Dubbele pijlen rechts",
    "chevrons-up": "Chevrons omhoog",
    "circle": "Cirkel",
    "clipboard": "Klembord",
    "clipboard-filled": "Klembord gevuld",
    "clock": "Klok",
    "clock-filled": "Klok gevuld",
    "clock-time-back": "Klok tijd terug",
    "close": "Sluiten",
    "cloud": "Wolk",
    "cloud-drizzle": "Wolk motregen",
    "cloud-light-rain": "Wolk lichte regen",
    "cloud-lightning": "Wolk bliksem",
    "cloud-rain": "Wolk regen",
    "code": "Code",
    "coffee": "Koffie",
    "compas": "Kompas",
    "corner-down-left": "Hoek omlaag links",
    "corner-down-right": "Hoek omlaag rechts",
    "corner-left-down": "Hoek links omlaag",
    "corner-left-up": "Hoek links omhoog",
    "corner-right-down": "Hoek rechts omlaag",
    "corner-right-up": "Hoek rechts omhoog",
    "corner-up-left": "Hoek omhoog links",
    "corner-up-right": "Hoek omhoog rechts",
    "counting": "Tellen",
    "cross": "Kruis",
    "decrease": "Verlagen",
    "diamond": "Diamant",
    "diner": "Dineren",
    "discount": "Korting",
    "dot": "Punt",
    "dry-cleaning": "Droogstomen",
    "edit": "Bewerken",
    "edit-3": "Bewerken 3",
    "electric": "Elektrisch",
    "email": "E-mail",
    "euro": "Euro",
    "external-link": "Externe link",
    "extreme": "Extreem",
    "eye": "Oog",
    "eye-off": "Oog uit",
    "facebook": "Facebook",
    "fast-forward": "Snel vooruit",
    "film": "Film",
    "filter": "Filter",
    "flag": "Vlag",
    "folder": "Map",
    "fork-knife": "Vork en mes",
    "gift": "Cadeau",
    "globe": "Bol",
    "google": "Google",
    "grade": "Cijfer",
    "grid": "Raster",
    "hash": "Hash",
    "headphones": "Koptelefoon",
    "healing": "Genezing",
    "heart": "Hart",
    "heart-plus": "Hart plus",
    "help-circle": "Hulp cirkel",
    "home": "Thuis",
    "home-alt": "Thuis alt",
    "hotel-spa": "Hotel spa",
    "image": "Afbeelding",
    "increase": "Verhogen",
    "info": "Info",
    "info-filled": "Info gevuld",
    "instagram": "Instagram",
    "label": "Label",
    "layers": "Lagen",
    "light-bulb": "Gloeilamp",
    "link": "Link",
    "linkedin": "LinkedIn",
    "list-filled": "Lijst gevuld",
    "loading": "Laden",
    "location": "Locatie",
    "location-filled": "Locatie gevuld",
    "lock": "Vergrendelen",
    "log-in": "Inloggen",
    "log-out": "Afmelden",
    "logo-mark": "Logomerk",
    "logout": "Afmelden",
    "mail": "E-mail",
    "male-female": "Man-vrouw",
    "man": "Man",
    "man-and-woman": "Man en vrouw",
    "map": "Kaart",
    "massage": "Massage",
    "maximize": "Maximaliseren",
    "maximize-2": "Maximaliseren 2",
    "menu": "Menu",
    "message": "Bericht",
    "min": "Min",
    "minus": "Min",
    "mix": "Mengen",
    "moon": "Maan",
    "more-vertical": "Meer verticaal",
    "move": "Verplaatsen",
    "mug": "Mok",
    "navigation": "Navigatie",
    "no-camera": "Geen camera",
    "no-video": "Geen video",
    "opties1": "Opties1",
    "options": "Opties",
    "package": "Pakket",
    "pencil": "Potlood",
    "percentage": "Percentage",
    "persons": "Personen",
    "phone": "Telefoon",
    "play": "Afspelen",
    "plus": "Plus",
    "plus-circle": "Plus cirkel",
    "plus-circle-filled": "Plus cirkel gevuld",
    "plus-square": "Plus vierkant",
    "pocket": "Zak",
    "power": "Stroom",
    "preferences": "Voorkeuren",
    "printer": "Printer",
    "profile": "Profiel",
    "qr-code-scanner": "QR-code scanner",
    "question-mark-circle": "Vraagteken cirkel",
    "quote": "Citaat",
    "radio": "Radio",
    "redeem": "Inwisselen",
    "refresh-ccw": "Vernieuwen linksom",
    "refresh-cw": "Vernieuwen rechtsom",
    "relaxation": "Ontspanning",
    "repeat": "Herhalen",
    "restaurant": "Restaurant",
    "rewind": "Terugspoelen",
    "rotate-ccw": "Linksom draaien",
    "rotate-cw": "Rechtsom draaien",
    "rss": "RSS",
    "scan-barcode": "Streepjescode scannen",
    "scent": "Geur",
    "scissors": "Schaar",
    "search": "Zoeken",
    "send": "Verzenden",
    "server": "Server",
    "settings": "Instellingen",
    "share": "Delen",
    "share-2": "Delen 2",
    "shield": "Schild",
    "shopping-bag-high": "Winkeltas hoog",
    "shopping-bag-low": "Winkeltas laag",
    "shopping-cart": "Winkelwagen",
    "sliders": "Schuifregelaars",
    "sound": "Geluid",
    "star": "Ster",
    "star-half": "Halve ster",
    "star-outline": "Ster omtrek",
    "stress-management": "Stressmanagement",
    "suitcase-filled": "Koffer gevuld",
    "sun": "Zon",
    "sunrise": "Zonsopgang",
    "sunset": "Zonsondergang",
    "swipe": "Vegen",
    "tag": "Label",
    "target": "Doel",
    "thermometer": "Thermometer",
    "thermostat": "Thermostaat",
    "thumbs-down": "Duim omlaag",
    "thumbs-up": "Duim omhoog",
    "tick": "Vink",
    "ticket": "Kaartje",
    "tickets": "Kaartjes",
    "tiktok": "TikTok",
    "toggle-left": "Schakelaar links",
    "toggle-right": "Schakelaar rechts",
    "tooltip": "Tooltip",
    "towel": "Handdoek",
    "trash": "Prullenbak",
    "trash-alt": "Prullenbak alt",
    "treatment": "Behandeling",
    "tv": "TV",
    "type": "Type",
    "umbrella": "Paraplu",
    "underline": "Onderstrepen",
    "upload": "Uploaden",
    "upload-cloud": "Cloud uploaden",
    "user": "Gebruiker",
    "user-check": "Gebruiker controleren",
    "user-minus": "Gebruiker minus",
    "user-plus": "Gebruiker plus",
    "users": "Gebruikers",
    "video": "Video",
    "videos": "Video's",
    "volume": "Volume",
    "volume-1": "Volume 1",
    "volume-2": "Volume 2",
    "volume-x": "Volume x",
    "voucher": "Bon",
    "water-drop": "Waterduppel",
    "wellness-retreat": "Wellness-retreat",
    "wifi": "WiFi",
    "wifi-off": "Wifi uit",
    "wine-glass": "Wijnglas",
    "woman": "Vrouw",
    "x": "X",
    "youtube": "YouTube",
    "zoom-in": "Inzoomen",
    "zoom-out": "Uitzoomen",
    "zoover": "Zoover"
}
